import { inject, provide } from 'vue';
import { useCurrentWorkflowStore } from '@/stores/workflow/currentWorkflow';
import { useWorkflowConditionEditor, type UseWorkflowConditionEditorReturn } from './useWorkflowConditionEditor';

const INJECTED_EDITOR_KEY = Symbol('conditionEditor');

export const useWorkflowConditionEditorProvider = () => {
  const workflowStore = useCurrentWorkflowStore();

  const makeFilterEditor = () =>
    useWorkflowConditionEditor({
      type: 'filter',
      getDefinitionList: () => workflowStore.currentDefinition.filters,
      getCurrentExpression: () => workflowStore.currentWorkflow.filter_condition?.expression,
    });

  const makeExitCriteriaEditor = () =>
    useWorkflowConditionEditor({
      type: 'exit_criteria',
      getDefinitionList: () => workflowStore.currentDefinition.exit_criteria,
      getCurrentExpression: () => workflowStore.currentWorkflow.exit_criteria_condition?.expression,
    });

  const provideEditor = (editor: UseWorkflowConditionEditorReturn) => {
    provide<UseWorkflowConditionEditorReturn>(INJECTED_EDITOR_KEY, editor);
  };

  return { makeFilterEditor, makeExitCriteriaEditor, provideEditor };
};

export const useInjectedConditionEditor = () => {
  const editor = inject<UseWorkflowConditionEditorReturn>(INJECTED_EDITOR_KEY);
  if (!editor) throw new Error('useInjectedConditionEditor must be used after provideWorkflowConditions');
  return editor;
};
